import React from "react";
import PropTypes from "prop-types";

export default function Save({
  submitting,
  icon = "fa-check",
  text = "Save",
  size = "lg"
}) {
  return (
    <button
      disabled={submitting}
      type="submit"
      className={`btn btn-block btn-${size} btn-primary`}
    >
      <i className={`fa fa-fw ${icon}`} />
      {text}
    </button>
  );
}

Save.propTypes = {
  submitting: PropTypes.bool,
  icon: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/Save/Save.jsx